import _regeneratorRuntime from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _this = this;

import * as tslib_1 from "tslib";
import { encode } from '../jsonEncode';
import { LoginApiUrl } from '@tradingblock/types';
import { LogoutTokenUrl } from '../constants';
export function TryLogin(values, options) {
  return tslib_1.__awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var host, loginUrl;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            host = options.host || '';
            loginUrl = host + (options.subdirectory ? options.subdirectory : '') + LoginApiUrl(options.subroot);
            _context.next = 4;
            return fetch(loginUrl, {
              method: 'post',
              body: JSON.stringify({
                encoded: encode(values)
              }),
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(function (res) {
              return res.json();
            }).then(function (json) {
              return json;
            });

          case 4:
            return _context.abrupt("return", _context.sent);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}
var httpOptions = {
  headers: {
    Accept: 'application/json'
  }
};
export var auth = function auth(api) {
  return {
    logout: function logout() {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", api.authenticated().post(LogoutTokenUrl, {}, httpOptions));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
  };
};